function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.description.js";
/** Decorator to set traitClass options (eg `description` of the class) */
export function traitClass(options) {
  return function (target) {
    target.description = options.description;
    target.example = options.example;
  };
}
export default class Trait {
  constructor(id, options, parent) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "decoratorForFlattened", void 0);
    _defineProperty(this, "parent", void 0);
    this.id = id;
    this.name = options.name;
    this.description = options.description;
    this.parent = parent;
  }
}
_defineProperty(Trait, "description", void 0);
_defineProperty(Trait, "example", void 0);